import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { forwardRef } from 'react';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AlertSnack = ({ response, open, setOpen, setLoading }) => {
  setLoading(false)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  // useEffect(() => {
  //   if (response.status === "success") {
  //     navigate(`'/customers`);
  //   }
  // }, [])


  // const handleResponse = (data) => {
  //   setLoading(false);
  //   setMsg(data.msg);
  //   setSeverity(data.status);
  //   setOpen(true);
  //   // if (data.status === "success") {
  //   //   navigate("/customers")
  //   // }
  // }


  return (
    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={response.status} sx={{ width: '100%' }}>
        {response.msg}
      </Alert>
    </Snackbar>
  )
}

export default AlertSnack